exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50}.header-links{width:400px;max-width:100%;display:inline-block;padding:0;margin-top:20px;margin-bottom:0}@media screen and (min-width:768px){.header-links{margin-top:50px;margin-bottom:30px}}.header-spacer{text-align:center;width:24%;list-style-type:none;display:inline-block}a{text-decoration:none;color:#000;font-weight:600;white-space:nowrap}.header-link{font-size:1.2rem;text-shadow:none;font-weight:400;padding-right:.2rem}.header-link.router-link-active{font-weight:600}.main-content{width:600px;max-width:100%;display:inline-block}.slide-right-enter-active{transition:all .3s ease}.slide-right-enter{transform:translateX(-50px);opacity:0}.slide-left-enter-active{transition:all .3s ease}.slide-left-enter{transform:translateX(50px);opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-7c096018","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 21
// module chunks = 0